import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  contactButton: {
    flex: 1,
  },
  actions: {
    padding: theme.spacing(2),
  },
  content: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  message: {
    marginTop: theme.spacing(2),
  },
  modalContainer: {
    margin: "auto",
    maxWidth: "480px",
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(2),
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
  },
}));

interface ComponentPropsType {
  onDismiss: () => void;
  open: boolean;
}

const ModalPaymentRequired = ({ onDismiss, open }: ComponentPropsType) => {
  const { classes } = useStyles();

  return (
    <Dialog
      aria-labelledby="payment-required-dialog-title"
      className={classes.modalContainer}
      onClose={onDismiss}
      open={open}
      PaperProps={{ square: true }}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onDismiss}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={classes.content}>
        <Typography
          className={classes.title}
          id="payment-required-dialog-title"
          variant="h6"
        >
          Swept access is temporarily unavailable
        </Typography>
        <Typography className={classes.message}>
          You&apos;re unable to access this account right now. Please contact
          your service provider or account admin if you need assistance.
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          className={classes.contactButton}
          component="a"
          href="mailto:support@sweptworks.com"
          rel="noopener noreferrer"
          target="_blank"
          variant="contained"
        >
          Contact Service Provider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalPaymentRequired;
